// import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { socket } from "./socket";
import DialerTab from "./screens/home/DialerTab"; // Import DialerTab

import LandingPage from "./screens/LandingPage/Landing";
import { Privacy } from "./screens/privacy/Privacy";
import { Login } from "./screens/auth/Login";
import { Signup } from "./screens/auth/Signup";
import { ResetPassword } from "./screens/auth/ResetPassword";
import { VerifyEmailPending } from "./screens/auth/VerifyEmailPending";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ProtectedRoute from "./screens/auth/ProtectedRoute";
import HomeLayout from "./screens/home/HomeLayout";
import Dashboard from "./screens/home/Dashboard";
import Notes from "./screens/home/notes/Notes";
import Meeting from "./screens/home/Meeting";
import Uploads from "./screens/home/Uploads";
import PreCallInsights from "./screens/home/PreCallInsights";
import Team from "./screens/home/Team";
import Settings from "./screens/settings/Settings";
import Rules from "./screens/home/Rules";
import Onboarding from "./screens/onboarding/Onboarding";
import SalesInbox from "./screens/home/inbox/SalesInbox";
import MeetingDetails from "./screens/home/MeetingDetails";
import { Contact } from "./screens/contact/Contact";
import LandingPricing from "./screens/LandingPage/LandingPricing";
import Clientonboarding from "./screens/home/Clientonboarding";
import Insights from "./screens/home/insights/Insights";
import Notifications from "./screens/home/notifications/Notifications";
import Coaching from "./screens/home/Coaching";
import { Payment } from "./screens/home/Payment";
import NotFound from "./screens/errors/NotFound";
import ManagerDashboard from "./screens/home/ManagerDashboard";
import UserDetails from "./screens/home/UserDetails";
import LeadDetail from "./screens/home/LeadDetail";
import TaskList from "./screens/home/TaskList";
import TasksPage from "./screens/home/TasksPage";
import PaymentSuccess from './screens/settings/PaymentSuccess';
import PaymentFailed from './screens/settings/PaymentFail';
import PaymentPending from './screens/settings/PaymentPending';

// Landing Page Components
import ProductPages from "./screens/LandingPage/components/products/ProductPages";
import SolutionIndustries from "./screens/LandingPage/components/solutions/SolutionIndustries";
import SolutionUseCases from "./screens/LandingPage/components/solutions/SolutionUseCases";
import PricingFinal from "./screens/LandingPage/PricingFinal";
import TermsOfService from "./screens/LandingPage/TermsOfService";
import PrivacyPolicy from "./screens/LandingPage/PrivacyPolicy";

// ====== Centralized Canonical Setter ======
function CanonicalSetter() {
  const location = useLocation();

  useEffect(() => {
    let canonicalLink = document.querySelector("link[rel='canonical']");

    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }

    canonicalLink.setAttribute("href", window.location.origin + location.pathname);
  }, [location]);

  return null;
}
// ==========================================



// --- Global Call State ---
// Mock simulation removed as per user request

export default function App() {
  const [gmailBadgeVisible, setGmailBadgeVisible] = useState(false);

  // 📨 Initialize socket connection ASAP
  useEffect(() => {
    console.log("🔌 Initializing Socket Connection...");
    console.log("📍 Socket URL:", socket.io?.uri);
    console.log("🔑 Auth token:", localStorage.getItem("authToken") ? "✅ Present" : "❌ Missing");
    
    // Connect socket immediately if not already connected
    if (!socket.connected && !socket.connecting) {
      console.log("🔗 Socket attempting to connect...");
      socket.connect();
    }

    // Socket connection successful
    const handleConnect = () => {
      console.log("✅ Socket Connected! ID:", socket.id);
      console.log("🎯 Socket is ready to receive events");
    };

    // Socket connection error
    const handleConnectError = (error) => {
      console.error("❌ Socket Connection Error:", error);
      console.error("⚠️ Socket might not be available for events");
    };

    // Socket disconnect
    const handleDisconnect = (reason) => {
      console.warn("⚠️ Socket Disconnected. Reason:", reason);
    };

    // Gmail disconnected event listener
    const handleGmailDisconnected = (data) => {
      console.log("🔴 Gmail Disconnected Event Received from Backend!", data);
      // Persist disconnect state so Settings page can always show reconnect option
      localStorage.setItem("gmailDisconnected", "true");
      setGmailBadgeVisible(false); // badge removed from top-right corner
    };

    // Attach listeners
    socket.on("connect", handleConnect);
    socket.on("connect_error", handleConnectError);
    socket.on("disconnect", handleDisconnect);
    socket.on("gmail_disconnected", handleGmailDisconnected);

    // Log current state
    console.log("📊 Socket State:", {
      connected: socket.connected,
      connecting: socket.connecting,
      id: socket.id,
      listeners: "gmail_disconnected attached"
    });

    // Cleanup
    return () => {
      socket.off("connect", handleConnect);
      socket.off("connect_error", handleConnectError);
      socket.off("disconnect", handleDisconnect);
      socket.off("gmail_disconnected", handleGmailDisconnected);
    };
  }, []);

  // Track gmail badge visibility changes
  useEffect(() => {
    console.log("🔔 gmailBadgeVisible state changed to:", gmailBadgeVisible);
  }, [gmailBadgeVisible]);

  const userData = (() => {
    try {
      return JSON.parse(localStorage.getItem("userData") || "{}");
    } catch (e) {
      return {};
    }
  })();
  const role = userData?.role;

  return (
    <div className="App">
        {/* Gmail reconnect is now handled in Settings > Permissions */}

      {/* Global Dialer Component Removed - Now handled in specific screens like ManageLeads */ }

      <GoogleOAuthProvider
        //  clientId="238999857779-10pnd8180q16e7akjc6dved71btr1i9e.apps.googleusercontent.com"
        clientId="283556775570-itlqv5m6c3b0a5f6hti612bk4gb0vfp5.apps.googleusercontent.com"
      >
        <Router>
          {/* Canonical Setter for all routes */ }
          <CanonicalSetter />
          {/* <button onClick={handleRunCallSimulation} style={{position:'fixed', top:0, left:0, zIndex:9999, opacity:0}}>Test Call</button> */ }

          <Routes>
            <Route path="/" element={ <LandingPage /> } />
            <Route path="/privacy" element={ <Privacy /> } />
            <Route path="/contact" element={ <Contact /> } />
            <Route path="/pricing" element={ <PricingFinal /> } />
            <Route path="/terms-of-service" element={ <TermsOfService /> } />
            <Route path="/privacy-policy" element={ <PrivacyPolicy /> } />
            
            {/* Product Routes */}
            <Route path="/products/:slug" element={ <ProductPages /> } />
            
            {/* Solution Routes */}
            <Route path="/solutions/industries/:slug" element={ <SolutionIndustries /> } />
            <Route path="/solutions/use-cases/:slug" element={ <SolutionUseCases /> } />
            
            <Route path="/login" element={ <Login /> } />
            <Route path="/signup" element={ <Signup /> } />
            <Route path="/reset-password" element={ <ResetPassword /> } />
            <Route path="/verify-email-pending" element={ <VerifyEmailPending /> } />
            <Route path="/onboarding" element={ <Onboarding /> } />
            <Route path="/payment" element={ <Payment /> } />

            <Route element={ <ProtectedRoute /> }>
              <Route path="/home" element={ <HomeLayout /> }>
                <Route index element={ <Dashboard /> } />
                <Route path="notes" element={ <Notes /> } />
                <Route path="events" element={ <Notes /> } />
                <Route path="meeting" element={ <Meeting /> } />
                <Route path="meeting/:id" element={ <MeetingDetails /> } />
                <Route path="uploads" element={ <Uploads /> } />
                <Route path="pre-call-insights" element={ <PreCallInsights /> } />
                <Route path="inbox" element={ <SalesInbox /> } />
                <Route path="insights" element={ <Insights /> } />
                <Route path="team" element={ <Team /> } />
                <Route path="manager" element={ <ManagerDashboard /> } />
                <Route path="new-task" element={ <TaskList /> } />
                <Route path="tasks" element={ <TasksPage /> } />
                <Route path="member/:id" element={ <UserDetails /> } />
                <Route path="lead/:id" element={ <LeadDetail /> } />
                <Route path="settings/*" element={ <Settings /> } />
                <Route path="rules" element={ <Rules /> } />
                <Route path="clientonboarding" element={ <Clientonboarding /> } />
                <Route path="notifications" element={ <Notifications /> } />
                <Route path="coaching/:meetingId" element={ <Coaching /> } />
                <Route path="coaching" element={ <Coaching /> } />


                {/* Settings Payment Routes - Protected */ }
                <Route path="settings/success" element={ <PaymentSuccess /> } />
                <Route path="settings/failed" element={ <PaymentFailed /> } />
                <Route path="settings/pending" element={ <PaymentPending /> } />
                <Route path="*" element={ <NotFound /> } />
              </Route>
            </Route>

            <Route path="*" element={ <NotFound /> } />
          </Routes>
        </Router>
      </GoogleOAuthProvider>
    </div>
  );
}
